import React, { useEffect, useState } from "react";
import "Styles/layouts/_Intro-layout.scss";
import * as Icons from "react-bootstrap-icons";
import { read } from "Helpers/LocalStorage";
import { useTranslation } from "react-i18next";

export default function ValidationFailed({ forcedCondition = false }) {
  const { t } = useTranslation();
  const CDW = read("CDW");
  const [data, setData] = useState(null);
  useEffect(() => {
    if (CDW) setData(JSON.parse(atob(CDW)));
  }, [CDW]);

  return (
    <>
      {(forcedCondition || (data && !data?.Active)) && (
        <div className="validation-failed">
          <div className="validation-failed-text">
            <Icons.ExclamationTriangleFill />
            <h4>{t("invalidWebSite_t1")}</h4>
            <h6>{t("invalidWebSite_t2")}</h6>
          </div>
        </div>
      )}
    </>
  );
}
